import {
  StructuredTableColumn,
  TagValueStructuredTableColumn,
} from 'notebook/structured-tables/StructuredTableConstants';
import {TableColumnType} from 'notebook/tables/TableConstants';

/**
 * Determine if the column is fillable in the data entry assistant feature.
 *
 * This should match the logic in FlexibleDataEntryTableContext._is_column_fillable on the backend.
 */
export default function isStructuredTableColumnFillable(column: StructuredTableColumn): boolean {
  if (column.isReadOnly || column.isProtected) {
    return false;
  }
  if (column.columnType === TableColumnType.TAG_VALUE) {
    // Unsafe cast due to type complexity, but this ideally would narrow to TagValueStructuredTableColumn.
    const tagValueColumn = column as TagValueStructuredTableColumn;
    if (
      tagValueColumn.schemaFieldIsComputed ||
      tagValueColumn.schemaFieldIsSnapshot ||
      tagValueColumn.schemaFieldIsConvertedFromLink
    ) {
      return false;
    }
  }
  return true;
}
